import { enablement } from './role'

export const queries = {
  enablement,
}
export default queries
